<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <DailyReportDetailTable/>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import DailyReportDetailTable from './DailyReportDetailTable.vue'

  export default {
    name: 'DailyRepportPage',
    components: { DailyReportDetailTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/member/DailyReportDetail.vue